import Salesinfo from "../../../jsx/components/Dashboard/salesinfo/salesinfo";

const SalesInfoWrapper = () => {
  return <Salesinfo />;
};

export default constore(SalesInfoWrapper);
